import { useEffect, useState } from "react";
import { Container, Row, Col, Button, Table } from "react-bootstrap";
import { APY, DEFAULT_CHAIN, UPTOAPY, contract, formatDate, formatDateWithZone } from "../helper/constant";
import { formatPrice, getAPY, getContract, getMultiCall } from "../helper/contractHelper";
import { toast } from 'react-toastify';
import tokenAbi from '../json/token.json';
import stakeAbi from '../json/bscstake.json';
import { ethers } from "ethers";
import { getWeb3 } from "../helper/connectors";
import { useAccountStats } from "../hooks/useBscAccount";
import { useCommonStats } from "../hooks/useBscCommon";
import curveLeft from '../Assets/img/why-token-curve-left.png';
import curveRight from '../Assets/img/why-token-curve-right.png';
import bscIcon from '../Assets/img/bsc-icon.png';
import infoImg from '../Assets/img/info.png';
import 'react-tooltip/dist/react-tooltip.css'
import { Tooltip } from 'react-tooltip'
import Referral from "./Referral";
import { useLocation } from 'react-router-dom';
import iconImg from '../Assets/img/icon.png';
import Slider from 'react-rangeslider'
import 'react-rangeslider/lib/index.css';
import { useAccount, useNetwork } from "wagmi";
import { useEthersSigner } from "../hooks/useEthersProvider";
import binanceChainImg from '../Assets/img/binance-chain.png';
import shoppingImg from '../Assets/img/shopping.png';
import websiteImg from '../Assets/img/website.png';
import youtubeImg from '../Assets/img/youtube.png';
import { useWeb3Modal  } from '@web3modal/react';




function Home() {
    const { address, isConnected } = useAccount()
    const { chain } = useNetwork();
    const signer = useEthersSigner()
    const [updater, setUpdater] = useState(new Date());
    const commonStats = useCommonStats(updater);
    const accStats = useAccountStats(updater);
    const [loading, setLoading] = useState(false);
    const [amount, setAmount] = useState(0);
    const [days, setDays] = useState(8760);
    const [endTime, setEndTime] = useState(false);
    const [tLoading, setTLoading] = useState(['', false]);
    const [slotRevenue, setSlotRevenue] = useState([]);
    const [ereturn, setEreturn] = useState(0);
    const [refAddress, setRefAddress] = useState('');
    const search = useLocation().search;
    const [amountkey, setAmountkey] = useState(0);
    const [endDate, setEndDate] = useState(` - `);
    const [apy, setApy] = useState(0);
    let web3 = getWeb3(DEFAULT_CHAIN);
    const { open } = useWeb3Modal()


    const handleApprove = async () => {
        if (address) {
            if (chain.id === DEFAULT_CHAIN && commonStats.FutureCoin !== '') {
                try {

                    setLoading(true);

                    let tokenContract = getContract(tokenAbi, commonStats.FutureCoin, signer);
                    let amount1 = ethers.utils.parseEther('1000000000000').toString();

                    let tx = await tokenContract.approve(contract[DEFAULT_CHAIN].STAKE_ADDRESS, amount1, { 'from': address });
                    const resolveAfter3Sec = new Promise(resolve => setTimeout(resolve, 5000));
                    toast.promise(
                        resolveAfter3Sec,
                        {
                            pending: 'Waiting for confirmation',
                        }
                    )

                    var interval = setInterval(async function () {
                        let web3 = getWeb3(DEFAULT_CHAIN);
                        var response = await web3.eth.getTransactionReceipt(tx.hash);
                        if (response != null) {
                            clearInterval(interval)
                            if (response.status === true) {
                                toast.success('success ! your last transaction is success 👍');
                                setLoading(false);
                                setUpdater(new Date());
                            }
                            else if (response.status === false) {
                                toast.error('error ! Your last transaction is failed.');
                                setLoading(false);
                                setUpdater(new Date());
                            }
                            else {
                                toast.error('error ! something went wrong.');
                                setLoading(false);
                                setUpdater(new Date());
                            }
                        }
                    }, 5000);
                }
                catch (err) {
                    console.log(err.message)
                    toast.error(err.reason ? err.reason : err.message);
                    setLoading(false);
                }
            }
            else {
                toast.error('Please select Binance Mainnet Network !');
                setLoading(false);
            }

        }
        else {
            toast.error('Please Connect Wallet!');
            setLoading(false);
        }
    }

    const handleStake = async () => {
        setLoading(true);
        try {
            if (commonStats.stakeAmounts && commonStats.stakeAmounts[amountkey] && amount) {
                if (address && isConnected) {
                    if (chain.id === DEFAULT_CHAIN) {

                        if (parseFloat(accStats.stakeTokenBalance) >= parseFloat(amount)) {

                            let tokenStakingAddress = contract[DEFAULT_CHAIN].STAKE_ADDRESS;
                            let stakeContract = getContract(stakeAbi, tokenStakingAddress, signer);
                            console.log(stakeContract)
                            let stakeTime = Math.floor(days * 60 * 60);

                            let refAddr = refAddress ? refAddress : '0x0000000000000000000000000000000000000000';

                            let tx = await stakeContract.stake(amountkey, stakeTime, refAddr, { 'from': address });
                            const resolveAfter3Sec = new Promise(resolve => setTimeout(resolve, 5000));
                            toast.promise(
                                resolveAfter3Sec,
                                {
                                    pending: 'Waiting for confirmation 👌',
                                }
                            )

                            var interval = setInterval(async function () {
                                let web3 = getWeb3(DEFAULT_CHAIN);
                                var response = await web3.eth.getTransactionReceipt(tx.hash);
                                if (response != null) {
                                    clearInterval(interval)
                                    if (response.status === true) {
                                        toast.success('success ! your last transaction is success 👍');
                                        setUpdater(new Date());
                                        setLoading(false);
                                    }
                                    else if (response.status === false) {
                                        toast.error('error ! Your last transaction is failed.');
                                        setUpdater(new Date());
                                        setLoading(false);
                                    }
                                    else {
                                        toast.error('error ! something went wrong.');
                                        setUpdater(new Date());
                                        setLoading(false);
                                    }
                                }
                            }, 5000);

                        }
                        else {
                            toast.error('you don\'t have enough balance !');
                            setLoading(false);
                        }

                    }
                    else {
                        toast.error('Please select Binance Mainnet Network !');
                        setLoading(false);
                    }
                }
                else {
                    toast.error('Please Connect Wallet!');
                    setLoading(false);
                }
            }
            else {
                toast.error('Please Enter Valid Amount !');
                setLoading(false);
            }
        }
        catch (err) {
            toast.error(err.reason);
            setLoading(false);
        }
    }

    const handleTerminate = async (index) => {
        setTLoading([index, true]);
        try {

            if (address && isConnected) {
                if (chain.id === DEFAULT_CHAIN) {
                    let tokenStakingAddress = contract[DEFAULT_CHAIN].STAKE_ADDRESS;
                    let stakeContract = getContract(stakeAbi, tokenStakingAddress, signer);

                    let tx = await stakeContract.claim(index, { 'from': address });
                    const resolveAfter3Sec = new Promise(resolve => setTimeout(resolve, 5000));
                    toast.promise(
                        resolveAfter3Sec,
                        {
                            pending: 'Waiting for confirmation',
                        }
                    )

                    var interval = setInterval(async function () {
                        let web3 = getWeb3(DEFAULT_CHAIN);
                        var response = await web3.eth.getTransactionReceipt(tx.hash);
                        if (response != null) {
                            clearInterval(interval)
                            if (response.status === true) {
                                toast.success('success ! your last transaction is success.');
                                setUpdater(new Date());
                                setTLoading(['', false]);
                            }
                            else if (response.status === false) {
                                toast.error('error ! Your last transaction is failed.');
                                setUpdater(new Date());
                                setTLoading(['', false]);
                            }
                            else {
                                toast.error('error ! something went wrong.');
                                setUpdater(new Date());
                                setTLoading(['', false]);
                            }
                        }
                    }, 5000);
                }
                else {
                    toast.error('Please select Binance Mainnet Network !');
                    setTLoading(['', false]);
                }
            }
            else {
                toast.error('Please Connect Wallet!');
                setTLoading(['', false]);
            }

        }
        catch (err) {
            toast.error(err.reason);
            setTLoading(['', false]);
        }
    }

    useEffect(() => {
        async function fetch() {
            try {
                if (commonStats.stakeAmounts && commonStats.stakeAmounts[amountkey]) {
                    let stakeContract = new web3.eth.Contract(stakeAbi, contract[DEFAULT_CHAIN].STAKE_ADDRESS);
                    let tamount = commonStats.stakeAmounts[amountkey];
                    let tokenAmount = await stakeContract.methods.getAmountsOut(tamount).call();

                    const timeElapsed = Date.now();
                    var Days = Math.floor(days / 24);
                    var Remainder = days % 24;
                    var Hours = Math.floor(Remainder);

                    let apy = getAPY(days)
                    let a = parseFloat(tokenAmount / Math.pow(10, 18))

                    setAmount(a);
                    setApy(apy);
                    setEreturn(a + (parseFloat(a * parseFloat(apy) * days * 3600) / (3153600000)));
                    setEndDate(`${Days} Days ${Hours} Hours`);
                    setEndTime(parseInt(timeElapsed) + parseInt(days * 60 * 60 * 1000));
                }
            }
            catch (err) {
                console.log(err.message);
            }
        }

        fetch();
        // eslint-disable-next-line
    }, [amountkey, days, commonStats])


    useEffect(() => {
        async function fetch() {
            if (address && isConnected) {
                let web3 = getWeb3(DEFAULT_CHAIN);
                let stakeContract = new web3.eth.Contract(stakeAbi, contract[DEFAULT_CHAIN].STAKE_ADDRESS);
                let length = accStats.stakeHistory.length;
                let getRevenueArray = [];

                for (let i = 0; i < length; i++) {
                    getRevenueArray[i] = stakeContract.methods.slotRevenue(address, i);
                }

                let revenueHistory = await getMultiCall(getRevenueArray);
                setSlotRevenue(revenueHistory);
            }
            else {
                setSlotRevenue([]);
            }

        }
        if (address && isConnected) {
            fetch();

            setInterval(() => {
                fetch();
            }, 60000);
        }
    }, [accStats, address])

    useEffect(() => {
        let refAddr = '';



        const queryChainId = new URLSearchParams(search).get('ref');
        if (queryChainId !== '') {
            refAddr = queryChainId;
        }
        setRefAddress(refAddr);
        // eslint-disable-next-line
    }, [])

    return (
        <>
            <section className="banner-section">

                <Container>
                    <Row>
                        <Col xs={12} md={6} lg={7}>
                            <h1>FutureCoin Earning <br />Dashboard</h1>
                            <a target="_blank" rel="noreferrer" href="https://pancakeswap.finance/swap?outputCurrency=0x24B045BCB46Dc84818ea98B0D6540049B313Dffa" className="theme-btn">Buy FutureCoin</a>
                            <h4>Powered by <img src={bscIcon} alt="bsc" /> <span>BSC</span></h4>
                            <div className="mb-4">
                                <a href="http://futurecoines.com/" target="_blank" rel="noreferrer" >
                                    <img src={websiteImg} alt="websiteImg" className="mx-2" height="35px" width="35px" />
                                </a>
                                <a href="https://ftcshopping.com/" target="_blank" rel="noreferrer" >
                                    <img src={shoppingImg} alt="shoppingImg" className="mx-2" height="35px" width="35px" />
                                </a>
                                <a href="http://futurecoines.com/vdo" target="_blank" rel="noreferrer" >
                                    <img src={youtubeImg} alt="youtubeImg" className="mx-2" height="35px" width="35px" />
                                </a>
                                <a href="https://bscscan.com/token/0x24b045bcb46dc84818ea98b0d6540049b313dffa/" target="_blank" rel="noreferrer" >
                                    <img src={binanceChainImg} alt="binanceChainImg" className="mx-2" height="35px" width="35px" />
                                </a>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={5}>
                            <div className="stake-box">
                                <div className="staking-info">
                                    <div className="all-info">
                                        <div className="label-1 text1">FutureCoin Amount</div>
                                        <div className="credit-stacked"><span className="highlight-span">{commonStats.totalStaked ? formatPrice(commonStats.totalStaked) : 0} {commonStats.tokenSymbol ? commonStats.tokenSymbol : '...'}</span></div>
                                    </div>
                                    <div className="all-info">
                                        <div className="label-1 text1">Total User</div>
                                        <div className="credit-stacked"><span className="highlight-span">{commonStats.totalStakers ? commonStats.totalStakers : 0}</span></div>
                                    </div>
                                    <div className="all-info">
                                        <div className="label-1 text1">CURRENT APY</div>
                                        <div className="credit-stacked"><span className="highlight-span">upto {UPTOAPY}%</span></div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="calculator-section" id="staking-section">
                <div className="curve-left">
                    <img src={curveLeft} alt="curve-left" />
                </div>
                <div className="curve-right">
                    <img src={curveRight} alt="curve-right" />
                </div>
                <Container>
                    <Row className="justify-content-center">
                        <Col xs={12} sm={12} md={8} lg={8}>
                            <div className="calc-box">
                                <div className="info-back">
                                    <h3>FutureCoin Earning</h3>
                                    <p>Earn FutureCoin get upto <span className="highlight-span">{UPTOAPY}% APY </span></p>
                                    <p>FutureCoin Balance : <span className="highlight-span">{accStats.stakeTokenBalance ? formatPrice(accStats.stakeTokenBalance) : 0} {accStats.tokenSymbol}</span></p>
                                    <p>FutureCoin Price : <span className="highlight-span" style={{color : "#00B259" , fontWeight : "700"}}>${commonStats.getTokenPrice ? formatPrice(commonStats.getTokenPrice, 3) : 0}</span>  </p>
                                </div>
                                <div className="content mt-3">
                                    <h5 className="text-center text-white">FutureCoin Plan</h5>
                                    <div className="stake-amounts">

                                        {commonStats && commonStats.stakeAmounts &&
                                            commonStats.stakeAmounts.map((value, key) => {
                                                return (

                                                    <button class={`btn-box ${key === amountkey ? 'active' : ''} amount-button`} onClick={() => setAmountkey(key)}>${formatPrice(value / Math.pow(10, 18))}</button>

                                                )
                                            })
                                        }

                                    </div>
                                    <div class="add-liquidity mt-3 mob-margin">
                                        <div class="content">
                                            <div class="d-flex align-items-center justify-content-between">
                                                <div class="labels"><h6>FutureCoin</h6></div>
                                                <div class="labels1 d-flex">
                                                    <input type="text" placeholder="" value={formatPrice(amount)} readOnly={true} />
                                                    <img src={iconImg} className="icon-img" alt="icon" />
                                                </div>
                                            </div>
                                            <p class="text-danger error-text"><small></small></p>
                                        </div>
                                    </div>
                                    <Slider
                                        progress
                                        min={0}
                                        step={1}
                                        max={43800}
                                        defaultValue={0}
                                        tooltip={true}
                                        value={days}
                                        format={value => `${value} Hours`}
                                        onChange={value => {
                                            setDays(value);
                                        }}
                                        className="mt-5"
                                    />

                                    <div className="col-12 d-flex justify-content-center mob-margin">
                                        {APY && APY.map((rowdata, key) => {
                                            return (
                                                <button class={`btn-box ${days === rowdata.time ? 'active' : ''}`} onClick={() => setDays(rowdata.time)}>
                                                    {rowdata.duration}
                                                </button>
                                            )

                                        })}
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between mt-4">
                                    <div className="labels">
                                        <h6>APY
                                            <img data-tooltip-id="Estimated" data-tooltip-content="apy for selected period." className="mx-1" height="20" width="20" src={infoImg} alt="info" />
                                            <Tooltip id="Estimated" />
                                        </h6>

                                    </div>
                                    <div className="labels">
                                        <h6>{apy ? apy : 0}%</h6>
                                    </div>
                                </div>

                                <div className="d-flex justify-content-between">
                                    <div className="labels">
                                        <h6>Estimated Return
                                            <img data-tooltip-id="Estimated" data-tooltip-content="Estimated return after endtime period." className="mx-1" height="20" width="20" src={infoImg} alt="info" />
                                            <Tooltip id="Estimated" />
                                        </h6>

                                    </div>
                                    <div className="labels">
                                        <h6>{ereturn ? `${formatPrice(ereturn)} ${commonStats.tokenSymbol ? commonStats.tokenSymbol : ''}` : '-'} </h6>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <div className="labels">
                                        <h6>Lock Days</h6>
                                    </div>
                                    <div className="labels">
                                        <h6>{endDate ? endDate : '-'}</h6>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <div className="labels">
                                        <h6>Lock Until Date</h6>
                                    </div>
                                    <div className="labels">
                                        <h6>{endTime ? formatDateWithZone(endTime) : ' - '}</h6>
                                    </div>
                                </div>

                                {/* <div className="plus-sys">
                                    <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><polyline points="19 12 12 19 5 12"></polyline></svg>
                                </div>
                                <h4>locked until {endDate ? endDate.toUTCString() : ' - '}</h4> */}
                                {
                                    address && isConnected ? (
                                        parseFloat(accStats.stakeTokenBalance) >= parseFloat(amount) ? (
                                        parseFloat(accStats.isApproved) >= parseFloat(amount) ? (
                                            <button className="theme-btn w-100 mt-3" disabled={loading} onClick={() => !loading ? handleStake() : null}>{loading ? 'Loading…' : 'Invest Now'}</button>
                                        ) : (
                                            <button className="theme-btn w-100 mt-3" disabled={loading} onClick={() => !loading ? handleApprove() : null}>{loading ? 'Loading…' : 'Approve'}</button>
                                        )) : (
                                            <button className="theme-btn w-100 mt-3" disabled={true}>Approve</button>
                                        )
                                        ) : (
                                        <button className="theme-btn w-100 mt-3" onClick={() => open()} >Connect Wallet</button>
                                    )
                                }

                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="details-section">
                <Container>
                    <Row>
                        <Col sm={12} md={6} lg={4}>
                            <div className="details-box">
                                <div className="title">Total Earn</div>
                                <h4>{accStats.totalStaked ? formatPrice(parseFloat(accStats.totalStaked) - parseFloat(accStats.totalUnStaked)) : 0} {commonStats.tokenSymbol ? commonStats.tokenSymbol : '...'}</h4>
                            </div>
                        </Col>
                        <Col sm={12} md={6} lg={4}>
                            <div className="details-box">
                                <div className="title">Total Claim</div>
                                <h4>{accStats.totalClaimed ? formatPrice(parseFloat(accStats.totalClaimed)) : 0} {commonStats.tokenSymbol ? commonStats.tokenSymbol : '...'}</h4>
                            </div>
                        </Col>
                        <Col sm={12} md={6} lg={4}>
                            <div className="details-box">
                                <div className="title">Avarage Earn Year</div>
                                <h4>3 Year</h4>
                            </div>
                        </Col>
                        <Col sm={12} md={6} lg={4}>
                            <div className="details-box">
                                <div className="title">Direct Referral</div>
                                <h4>{accStats.team0 ? accStats.team0 : 0}</h4>
                            </div>
                        </Col>
                        <Col sm={12} md={6} lg={4}>
                            <div className="details-box">
                                <div className="title">Referral Earning</div>
                                <h4>{accStats.rewardRef ? formatPrice(parseFloat(accStats.rewardRef)) : 0} {commonStats.tokenSymbol ? commonStats.tokenSymbol : '...'}</h4>
                            </div>
                        </Col>
                        <Col sm={12} md={6} lg={4}>
                            <div className="details-box">
                                <div className="title">Team</div>
                                <h4>{accStats.team0 && accStats.team1 && accStats.team2 ? parseFloat(accStats.team0) + parseFloat(accStats.team1) + parseFloat(accStats.team2) : 0}</h4>
                            </div>
                        </Col>
                    </Row>

                    <Row className="mt-5 mb-5">
                        <Col sm={12}>
                            <h3 className="text-white">Transaction Records</h3>
                            <Table bordered hover responsive>
                                <thead>
                                    <tr>
                                        <th>Earning Amount</th>
                                        <th>APY</th>
                                        <th>Reward</th>
                                        <th>Start Date(LocalTime)</th>
                                        <th>End Date(LocalTime)</th>
                                        <th>Time Left</th>
                                        <th>Claim
                                            <img data-tooltip-id="Unstake" data-tooltip-content=" You can claim if reward amount more then staked 5%" className="mx-1" height="20" width="20" src={infoImg} alt="info" />
                                            <Tooltip id="Unstake" />
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {accStats.stakeHistory.length > 0 ? (accStats.stakeHistory.map((row, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{row[0]._amount ? formatPrice(row[0]._amount / Math.pow(10, accStats.tokenDecimals)) : 0} {accStats.tokenSymbol ? accStats.tokenSymbol : ' - '}</td>
                                                <td>{row[0]._apy ? formatPrice(row[0]._apy / Math.pow(10, 2) , 3) : 0}%</td>
                                                <td><span style={{color : "#00B259" , fontWeight : "700"}}>{slotRevenue.length > 0 && slotRevenue[index] && slotRevenue[index][0] ? formatPrice(slotRevenue[index][0] / Math.pow(10, accStats.tokenDecimals) , 5) : 'loading...'} {accStats.tokenSymbol ? accStats.tokenSymbol : ' - '}</span></td>
                                                <td>{row[0]._startTime ? formatDate(row[0]._startTime * 1000) : ' - '}</td>
                                                <td>{row[0]._endTime ? formatDate(row[0]._endTime * 1000) : ' - '}</td>
                                                <td>{Math.round(Math.abs((row[0]._endTime - Math.floor(new Date().getTime()/1000.0)) / 86400))} Days</td>
                                                <td>
                                                    <button onClick={() => handleTerminate(index)} disabled={(tLoading[0] === index && tLoading[1]) || (slotRevenue.length > 0 && slotRevenue[index] && !slotRevenue[index][1])  ? true : false} type="button" className="theme-btn1">
                                                        {tLoading[0] === index && tLoading[1] ? 'Loading...' : 'Claim'}
                                                    </button>
                                                </td>
                                            </tr>
                                        )
                                    })

                                    ) : (
                                        <tr>
                                            <td colSpan={7}>
                                                <h5 className="m-0 text-white">You Have No Earn Record Yet.</h5>
                                            </td>
                                        </tr>
                                    )
                                    }
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    <Referral accStats={accStats} />
                </Container >
            </section >
        </>
    )
}

export default Home
